import { userStore } from "../store";

// TODO: should this be sanitising the user props before passing it AND don't use any here
//eslint-disable-next-line
export default (initUser: any) => {
  if (initUser) {
    userStore.user = initUser;

    navigator.serviceWorker.controller?.postMessage({
      action: "ADD_OFFLINE",
    });
  }
};
